<template>
  <div class="card shadow-sm form-card">
    <div class="form-card-header">
      <div class="section-number"><i class="fe fe-briefcase"></i></div>
      <h6 class="mb-0 font-weight-bold text-white">Change Department / Job Title</h6>
    </div>
    <div class="card-body px-4 pt-4 pb-3">
      <div class="form-row align-items-end">
        <div class="form-group col-md-8">
          <label class="small font-weight-bold text-secondary">Job Title</label>
          <select class="form-control" v-model="job_title">
            <option value="Executive Secretary">
              Executive Secretary
            </option>
            <option value="M and E">M and E</option>

            <option value="Finance">Finance</option>
            <option value="Claims Vetter">Claims Vetter</option>
            <option value="Claims Verifier">Claims Verifier</option>
            <option value="Enrollment Officer">
              Enrollment Officer
            </option>
            <option value="dashboard">Dashboard (view only)</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <button type="submit" class="btn btn-submit btn-block" @click="changeDept">
            <i class="fe fe-check mr-1"></i> Submit
          </button>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      job_title: "",
      response: "",
      isLoading: false,
      fullPage: true,
      auth_user: "",
      user: null,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    changeDept() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/update-dept/${this.$route.params.id}`, {
          job_title: this.job_title,
        })

        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Department Changed", {
            position: "top-center",
            duration: 3000,
          });
          // this.$router.push('/')
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$toasted.error("Dept. not changed", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
  },
  created() {},
};
</script>
